import React, { Fragment, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
// import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import HeightIcon from '@material-ui/icons/Height';
import SpeedIcon from '@material-ui/icons/Speed';
import {LanguageContext} from '../../context/LanguageContext'
import {BmiContext} from '../../context/BmiContext'
import {TypeContext} from '../../context/TypeContext'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: '25ch',
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },

      marginOnButton: {
        margin: theme.spacing(1),
      },
  }))

const BmiCalculator = () => {
    const classes = useStyles();
    const {btn: {calculateBtn, clearBmiBtn, clearAllBtn}} = useContext(LanguageContext)
      
    const {stateType: {selectedType}} = useContext(TypeContext);
    const {stateBMI: {bmi: {weight, height, bmiResult}}, onChange, clearAll, clearBmi, handleSubmit} = useContext(BmiContext);
    return(
        <Fragment>
    <div className={classes.root}>
      <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            {selectedType}
        <form onSubmit={handleSubmit}>
        <FormControl fullWidth className={classes.margin} variant="outlined">
          {/* <InputLabel htmlFor="outlined-adornment-weight">{inputWeight}</InputLabel> */}
          <OutlinedInput
            id="outlined-adornment-weight"
            onChange={onChange}
            name="weight"
            value={weight}
            endAdornment={<InputAdornment position="end"><SpeedIcon /></InputAdornment>}
            labelWidth={60}
          />
        </FormControl>
        <FormControl fullWidth className={classes.margin} variant="outlined">
          {/* <InputLabel htmlFor="outlined-adornment-height">{inputHeight}</InputLabel> */}
          <OutlinedInput
            id="outlined-adornment-height"
            onChange={(e) => onChange(e)}
            name="height"
            value={height}
            endAdornment={<InputAdornment position="end"><HeightIcon/></InputAdornment>}
            labelWidth={60}
          />
        </FormControl>
        {selectedType !== '' ? 
        <Button variant="contained" color="primary" type="submit">
            {calculateBtn}
        </Button>
        :  
        <div>
            Type a weight
        </div>
         } 
        </form>
        {/* <pre>{JSON.stringify(bmi, null)}</pre> */}
          </Paper>
        </Grid>
        <Grid item xs={bmiResult.length > 0 ? 12 : 12} sm={bmiResult.length > 0 ? 4 : 8}>
          <Paper className={classes.paper}>
              <h1>BMI</h1>
            <h2>{bmiResult}</h2>
          </Paper>
        </Grid> 
         {bmiResult.length > 0 ? 
        <Grid item xs={12} sm={4} >
            <Paper className={classes.paper}>
            <Button variant="contained" color="primary" onClick={clearBmi} className={classes.marginOnButton}>{clearBmiBtn}</Button>
            
            <Button variant="contained" color="primary" onClick={clearAll} className={classes.marginOnButton}>{clearAllBtn}</Button>
          </Paper>
        </Grid>
            : null} 
            </Grid> 
        </div>
        </Fragment>

    )
}


export default BmiCalculator